/* PokeMark theme interactions: Notify Me panels + signup tag wiring. */
(function () {
  'use strict';

  /* --- Notify Me: toggle inline capture panels --- */
  document.querySelectorAll('[data-pm-notify]').forEach(function (widget) {
    var btn = widget.querySelector('[data-pm-notify-btn]');
    var panel = widget.querySelector('[data-pm-notify-panel]');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var open = panel.hasAttribute('hidden');
      if (open) {
        panel.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
        var input = panel.querySelector('input[type="email"]');
        if (input) input.focus();
      } else {
        panel.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
    var form = widget.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        try { sessionStorage.setItem('pm_last_form', 'notify:' + (widget.getAttribute('data-pm-notify') || '')); } catch (e) {}
      });
    }
  });

  /* --- Drop-list signup: remember it was the submitted form --- */
  document.querySelectorAll('.pm-signup__form').forEach(function (form) {
    form.addEventListener('submit', function () {
      try { sessionStorage.setItem('pm_last_form', 'signup'); } catch (e) {}
    });
  });

  /* Customer forms are page-global: after a POST every rendered success
     block shows. Keep only the one belonging to the form actually sent. */
  try {
    var last = sessionStorage.getItem('pm_last_form') || '';
    if (last) {
      document.querySelectorAll('[data-pm-notify]').forEach(function (widget) {
        var ok = widget.querySelector('[data-pm-notify-ok]');
        if (!ok) return;
        if (last === 'notify:' + widget.getAttribute('data-pm-notify')) {
          var panel = widget.querySelector('[data-pm-notify-panel]');
          if (panel) panel.removeAttribute('hidden');
          var btn = widget.querySelector('[data-pm-notify-btn]');
          if (btn) btn.setAttribute('aria-expanded', 'true');
        } else {
          ok.setAttribute('hidden', '');
        }
      });
      document.querySelectorAll('.pm-signup__ok').forEach(function (ok) {
        if (last !== 'signup') ok.setAttribute('hidden', '');
      });
      sessionStorage.removeItem('pm_last_form');
    }
  } catch (e) {}

  /* --- Signup forms: fold the chosen set into customer tags --- */
  document.querySelectorAll('[data-pm-set-select]').forEach(function (select) {
    var form = select.closest('form');
    if (!form) return;
    var tagsInput = form.querySelector('input[name="customer[tags]"]');
    if (!tagsInput) return;
    var base = tagsInput.getAttribute('data-pm-base-tags') || tagsInput.value;
    select.addEventListener('change', function () {
      var slug = select.value;
      tagsInput.value = slug ? base + ', want-' + slug : base;
    });
  });
})();
